import {ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {SubSink} from 'subsink';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {Taxonomy} from '../taxonomy.reducer';
import {flatten} from '../../segment/segments.state';
import {TaxonomyFacadeService} from '../taxonomy-facade.service';

export interface TaxonomyFilterModel {
  name?: string;
  taxonomyIds?: number;
}

@Component({
  selector: 'app-taxonomy-filters',
  template: `
      <div [formGroup]="filtersForm" class="taxonomy-search-input-container">
          <div class="search-field-wrapper">
              <div class="left-column">
                  <mat-form-field id="input-taxonomy-name">
                      <input formControlName="name"
                             matInput
                             autocomplete="off"
                             placeholder="Taxonomy Name"/>
                  </mat-form-field>
              </div>
              <div class="right-column">
                  <mat-form-field>
                      <mat-label>Taxonomy</mat-label>
                      <mat-select formControlName="taxonomies"
                                  multiple>
                          <mat-option *ngFor="let taxonomy of taxonomySource$ | async"
                                      [value]="taxonomy"
                                      [ngStyle]="{paddingLeft: taxonomy.level? taxonomy.level*17 + 'px' : '5px'}">
                              ({{taxonomy.id}}) {{taxonomy.name}}
                          </mat-option>
                      </mat-select>
                  </mat-form-field>
              </div>
          </div>
          <button [disabled]="!showSearchFormClearButton()"
                  id="btn-clear-search"
                  color="primary"
                  class="clear-search-form-button"
                  mat-raised-button
                  (click)="clearSearch()">Clear
          </button>
      </div>
  `,
  styleUrls: ['./taxonomy-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxonomyFiltersComponent implements OnInit, OnDestroy {
  @Output() filterChanged = new EventEmitter<TaxonomyFilterModel>();
  taxonomySource$: Observable<Taxonomy[]> = this.taxonomyFacade.getAll().pipe(map(it => flatten(it)));
  filtersForm = new FormGroup({
    name: new FormControl(),
    taxonomies: new FormControl()
  });
  private subSink = new SubSink();

  constructor(private taxonomyFacade: TaxonomyFacadeService) {
  }

  ngOnInit(): void {
    this.subSink.sink = this.filtersForm.valueChanges.pipe(
      distinctUntilChanged()
    ).subscribe((value) => {
      this.filterChanged.emit({
        name: value.name,
        taxonomyIds: value.taxonomies?.map((it: Taxonomy) => it.id) || []
      });
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  clearSearch() {
    this.filtersForm.patchValue({});
  }

  showSearchFormClearButton() {
    return Object.keys(this.filtersForm.value)
      .some(formControlKey => {
        if (Array.isArray(this.filtersForm.value[formControlKey])) {
          return this.filtersForm.value[formControlKey].length > 0;
        }
        return !!this.filtersForm.value[formControlKey];
      });
  }

}
